import React from 'react';
import { Button } from '@mui/material';
import { AddIcon } from 'icons/materialIcons'; // Centralized icon
import getIconForType from 'utils/icons/getIconForType'; // Adjust the path as needed

const ContactLinkItem = ({ text, onClick, type }) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      sx={{
        backgroundColor: '#f5f5f5', // Lighter shade of #f1f1f1
        textTransform: 'none', // No capitalization
        fontSize: '0.75rem', // Smaller font size
        fontWeight: 'bold', // Make text bold
        borderColor: '#ddd', // Lighter border color
        color: '#555', // Slightly darker text color
        display: 'flex', // Flexbox for layout
        alignItems: 'center', // Center items vertically
        gap: 1, // Space between elements
        '&:hover': {
          backgroundColor: '#ececec', // Slightly darker shade on hover
        },
      }}
      startIcon={getIconForType(type)} // Get the icon for the item type
      endIcon={<AddIcon />} // Plus icon on the right side
    >
      {text}
    </Button>
  );
};

export default ContactLinkItem;